// extracted by mini-css-extract-plugin
export default {"MenuItem":"styles_MenuItem__GJOz4","Active":"styles_Active__7bKZ8"};